import React from 'react'
import PropTypes from 'prop-types'
import { Divider, Row, Col, Card } from 'antd'

const ItemImages = ({ item }) => {
  const _renderImage = (image, index) => (
    <Col span={6} key={index} className="ProductionProgress__ImageData">
      <Card
        hoverable
        cover={<img alt={index} src={image.thumbnail_url} height={250}/>}
      >
        <div className="ProductionProgress__ImageData__Quantity">Quantity: {image.quantity}</div>
      </Card>
    </Col>
  )

  return (
    <>
      <Divider orientation="right">Photos</Divider>
      <Row>
        <Col span={24}>
          <Row gutter={16} justify="space-around" align="middle">
            {item.images.map(_renderImage)}
          </Row>
        </Col>
      </Row>
    </>
  )
}

ItemImages.propTypes = {
  item: PropTypes.object
}

export default ItemImages
